import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loggedInState: false,
  userRole: "",
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    setLoggedInState: (state, action) => {
      state.loggedInState = action.payload;
    },
    setUserRole: (state, action) => {
      state.userRole = action.payload;
    },

    resetLoggedInState: (state) => {
      state.loggedInState = false;
      state.userRole = "";
    },
  },
});

export const { setLoggedInState, setUserRole, resetLoggedInState } =
  loginSlice.actions;

export default loginSlice.reducer;
